<template>
  <div class="top-bar">
    <div class="logo">
      <van-image
        width="120px"
        height="8px"
        fit="contain"
        :src="require('../assets/img/logo.png')"
      />
    </div>
    <div style="display: flex;align-items: start;line-height: 22px;">
      Hi, {{ roleName }}&nbsp;
      <van-badge :content="badgeNum ? badgeNum : null">
        <van-image
          @click="goNotice"
          :src="require('../assets/img/notice.png')"
          width="20px"
          height="20px"
        ></van-image>
      </van-badge>
      <!-- <van-icon name="chat-o" @click="goNotice" :badge="badgeNum ? badgeNum : null" /> -->
    </div>
  </div>
</template>

<script>
import { getNoticeNewNum } from '@/api/common/index.js'
export default {
  name: 'Top',
  data() {
    return {
      roleName: localStorage.getItem('userName'),
      isDot: true,
      badgeNum: 0,
    }
  },
  watch: {
    $route(val) {
      console.log('改变路由', val)
    },
  },
  created() {},
  mounted() {
    this.getNews()
  },
  methods: {
    getNews() {
      getNoticeNewNum({}).then((res) => {
        this.isDot = res.data == 0 ? false : true
        this.badgeNum = res.data
      })
    },
    goNotice() {
      this.$router.push('/notice')
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.top-bar {
  .van-badge {
    font-family: 'Porsche Next';
    font-size: 11px;
    //line-height: 14px;
  }
}
</style>
<style lang="scss" scoped>
.top-bar {
  display: flex;
  justify-content: space-between;
  height: 24px;
  padding: 15px 16px 0;
  margin-bottom: 10px;
  .van-info,
  .van-badge {
    font-family: 'Porsche Next';
  }
}
</style>
